import { useMemo } from 'react';
import { useMaterialReactTable, MaterialReactTable } from 'material-react-table';
import { connect } from 'react-redux';

const RawData = ({ data }) => {
  const columns = useMemo(
    () =>
      Object.keys(data[0] || {}).map((c) => {
        if (c === 'Timestamp')
          return {
            id: c,
            accessorFn: ({ Timestamp }) => new Date(Timestamp),
            header: c,
            filterVariant: 'date-range',
            // convert back to string for display
            Cell: ({ cell }) =>
              `${cell.getValue().toLocaleDateString()} ${cell.getValue().toLocaleTimeString()}`,
          };
        return {
          id: c,
          accessorFn: (datum) => datum[c],
          header: c,
          filterVariant: 'range',
        };
      }),
    [data]
  );
  const [minDate, maxDate] = useMemo(
    () =>
      data === undefined
        ? []
        : [new Date(data[0].Timestamp), new Date(data[data.length - 1].Timestamp)],
    [data]
  );
  const columnVisibility = Object.fromEntries(columns.map((col, i) => [col.id, i < 10]));
  const mrt = useMaterialReactTable({
    muiTableHeadCellProps: {
      sx: {
        textAlign: 'center',
        verticalAlign: 'middle',
        '& .Mui-TableHeadCell-Content': {
          justifyContent: 'center',
        },
      },
    },
    muiTableBodyCellProps: { sx: { textAlign: 'center', verticalAlign: 'middle' } },
    columns,
    data,
    initialState: {
      columnVisibility,
      columnFilters: [{ id: 'Timestamp', value: [minDate, maxDate] }],
    },
  });

  return <MaterialReactTable table={mrt} />;
};

export default connect()(RawData);
